export default __webpack_public_path__ + "static/media/link.0e6a383f.svg";